<template>
    <div class="chatview">
      <v-alert
        v-if="botConfig.limitUsageStatus && !botConfig.limitUsageStatus.unlimited_usage && botConfig.limitUsageStatus.limit_exceeded"
        icon="mdi-alert-circle"
        :value="true"
        class="chatview-header" style="padding: 16px; margin: 0; z-index: 11; height: auto;"
        dismissible
        type="error"
      >
        <b>{{ $t('warning') | capitalize }}: </b>{{ $t('limitUsageExceeded') }}
        <br/>
        {{ $t('contact') | capitalize }}: <b>{{ $t('contactHotline') | capitalize }}</b>
      </v-alert>
      <v-alert
        v-else-if="botConfig.limitUsageStatus && !botConfig.limitUsageStatus.unlimited_usage && botConfig.limitUsageStatus.show_warning"
        icon="mdi-alert-circle"
        :value="true"
        class="chatview-header" style="padding: 16px; margin: 0; z-index: 11; height: auto;"
        dismissible
        type="warning"
      >
        <b>{{ $t('warning') | capitalize }}: </b>{{ $t('limitUsageWarning') }}
        <br/>
        {{ $t('contact') | capitalize }}: <b>{{ $t('contactHotline') | capitalize }}</b>
      </v-alert>
        <template v-if="chatView && chatView.senderId">
            <div class="chatview-header">
                <v-layout align-center style="height: 100%">
                    <span class="show-on-lg-down">
                        <v-btn flat icon depressed color="#4977EE" class="back-to-list" @click="goToBotList">
                            <v-icon>mdi-arrow-left</v-icon>
                        </v-btn>
                    </span>
                    <img
                        v-if="chatView.customer.image"
                        :src="chatView.customer.image"
                        alt="customer icon"
                        class="customer-icon hide-on-md-down"
                    >
                    <div v-else class="staff-icon hide-on-md-down">
                        {{
                            chatView.customer.sender_name ? $AppService.createTextImage(chatView.customer.sender_name) : $AppService.createTextImage(chatView.senderId)
                        }}
                    </div>
                    <div style="padding-left: 12px" class="sender-n-supporter-name">
                        <v-layout align-center>
                            <img :src="'/assets/icons/platform/'+chatView.customer.sender_channel+'.svg'"
                                style="width: 16px; border-radius: 100%" class="mr-2">
                            <v-tooltip bottom max-width="40%">
                                <template v-slot:activator="{on}">
                                    <div class="sender-name" v-on="on">
                                        {{ chatView.customer.sender_name ? chatView.customer.sender_name : chatView.senderId }}
                                    </div>
                                </template>
                                <span>{{ chatView.customer.sender_name ? chatView.customer.sender_name : chatView.senderId }}</span>
                            </v-tooltip>
                        </v-layout>
                        <v-layout align-center class="supporter-name">
                            <span class="chat-supporter" :style="`background: ${chatSupporter.color}`">
                                {{chatSupporter.text}}
                            </span>
                            <span style="color: #888A9A" v-if="!botStatus && supporter">
                                {{supporter.email}}
                            </span>
                        </v-layout>
                    </div>
                    <!-- <v-spacer></v-spacer> -->
                    <v-menu bottom left>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" icon depressed class="not-custom-ui show-on-md-down">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black" width="26px" height="26px"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/></svg>
                            </v-btn>
                        </template>
                        <v-list class="conversation-menu">
                            <v-list-tile @click="toggleSessionInfo">
                                <v-list-tile-title>
                                    <v-icon color="#4977EE" class="mr-2">mdi-information-outline</v-icon>
                                    <span>{{ $t('sessionInfo')|capitalize }}</span>
                                </v-list-tile-title>
                            </v-list-tile>
                          <v-list-tile @click="openDialogBlockCustomer" v-if="canBlockCustomer">
                                <v-list-tile-title style="display: inline-flex">
                                  <img v-if="blockStatus === true" src="/icon/lock/unlock-blue.svg" alt="" class="mr-2">
                                  <img v-else src="/icon/lock/lock-blue.svg" alt="" class="mr-2">
                                  <span>{{ (blockStatus ? $t('unblockCustomer')  : $t('blockCustomer')) | capitalize }}</span>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="open_sendEmailConversation_dialog" v-if="canSendEmailConversation">
                                <v-list-tile-title>
                                    <v-icon color="#4977EE" class="mr-2">mdi-email-outline</v-icon>
                                    <span>{{ $t('sendConversationToEmail') }}</span>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="showSupporterConversation">
                                <v-list-tile-title>
                                    <v-icon color="#4977EE" class="mr-2">mdi-account-check-outline</v-icon>
                                    <span>{{displaySupporterConversation ? $t('showAllConversation') : $t('showConversationOfSupporter')}}</span>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="toggleNotes">
                                <v-list-tile-title>
                                    <v-icon color="#4977EE" class="mr-2">mdi-note-outline</v-icon>
                                    <span>{{ $t('notes')|capitalize }}</span>
                                </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="toggleTicket">
                                <v-list-tile-title>
                                    <v-icon color="#4977EE" class="mr-2">mdi-tag-outline</v-icon>
                                    <span>{{ $t('tickets')|capitalize }}</span>
                                </v-list-tile-title>
                                <v-list-tile-action style="min-width: 0px">
                                    <div class="badge-small text-xs-center" v-if="countOpening>0">{{countOpening > 9 ? '9+' : countOpening}}</div>
                                </v-list-tile-action>
                            </v-list-tile>
                            <v-list-tile v-if="me && supporter && supporter.id === me.id" @click="toggleMarkAsDone">
                                <v-list-tile-title>
                                    <v-icon color="#4977EE" class="mr-2">mdi-check-circle-outline</v-icon>
                                    <span>{{ $t('markAsDone') | capitalize }}</span>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                    <div class="hide-on-md-down">
                        <v-tooltip bottom>
                            <v-btn outline depressed dark color="#0052CC" @click="toggleSessionInfo" slot="activator">
                                <v-icon small :class="{'mr-1': !isSmallScreen}">mdi-information</v-icon>
                                <!-- <span v-if="!isSmallScreen">{{ $t('sessionInfo')|capitalize }}</span> -->
                            </v-btn>
                            <span>{{ $t('sessionInfo')|capitalize }}</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="canBlockCustomer">
                            <v-btn outline depressed dark color="#0052CC" slot="activator"
                                   @click="openDialogBlockCustomer"
                            >
                                <img v-if="blockStatus === true" src="/icon/lock/unlock-blue.svg" alt="">
                                <img v-else src="/icon/lock/lock-blue.svg" alt="">
                            </v-btn>
                            <span>{{ (blockStatus ? $t('unblockCustomer')  : $t('blockCustomer')) | capitalize }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn outline depressed dark color="#0052CC" slot="activator"
                                @click="open_sendEmailConversation_dialog"
                                v-if="canSendEmailConversation"
                            >
                                <img src="/icon/email.svg" alt="">
                            </v-btn>
                            <span>{{ $t('sendConversationToEmail') }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn outline depressed dark @click="showSupporterConversation" slot="activator"
                                :color="displaySupporterConversation ? '#4977EE' : '#7C7C7C'">
                                <v-icon small>{{ displaySupporterConversation ? 'mdi-account-check' : 'mdi-account-check-outline' }}</v-icon>
                            </v-btn>
                            <span>{{displaySupporterConversation ? $t('showAllConversation') : $t('showConversationOfSupporter')}}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn outline depressed dark color="#0052CC" @click="toggleNotes" slot="activator">
                                <img src="/icon/note.svg" alt="">
                                <!-- <span v-if="!isSmallScreen" class="ml-1">{{ $t('notes')|capitalize }}</span> -->
                            </v-btn>
                            <span>{{ $t('notes')|capitalize }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <v-btn outline depressed dark color="#0052CC" @click="toggleTicket" slot="activator">
                                <img src="/icon/ticket.svg" alt="">
                                <!-- <span v-if="!isSmallScreen" class="ml-1">{{ $t('tickets')|capitalize }}</span> -->
                                <div v-if="countOpening>0" class="badge">{{countOpening > 9 ? '9+' : countOpening}}</div>
                            </v-btn>
                            <span>{{ $t('tickets')|capitalize }}</span>
                            <span v-if="countOpening>0"> ({{countOpening}})</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="me && supporter && supporter.id === me.id">
                            <v-btn outline depressed dark color="#0052CC" @click="toggleMarkAsDone" slot="activator">
                                <v-icon small :class="{'mr-1': !isSmallScreen}">mdi-check-circle</v-icon>
                                <span v-if="!isSmallScreen">{{ $t('markAsDone') }}</span>
                            </v-btn>
                            <span>{{ $t('markAsDone') | capitalize }}</span>
                        </v-tooltip>
                    </div>
                </v-layout>
            </div>
            <div
                class="chatview-content"
                :class="{'show-rss': shouldShowRss, 'active-rss': !!rssActive}"
                ref="content"
                @scroll="contentScroll($event)"
            >
                <div style="text-align: center;" v-if="displayLoadingChatlogs">
                    <v-progress-circular
                        :size="20"
                        :width="2"
                        color="green"
                        indeterminate
                    ></v-progress-circular>
                </div>
                <div class="msg-holder" v-for="msg in chatLogsSortByTime" :key="'msg_index_' + msg.id">
                    <div class="session_hr_time" v-if="msg.first_session">
                        <hr>
                        <span class="span-session">{{ formatDateTime(msg.created_time) }}</span>
                    </div>
                    <SystemMessage
                        v-if="msg.source === 3 && msg.sender_type === 2"
                        :message="msg"
                    ></SystemMessage>
                    <Message
                        v-if="accept_message_types.includes(msg.type)"
                        :message="msg"
                        :customer="customer"
                        :isLastSeenMsg="last_user_seen_message && last_user_seen_message.id === msg.id"
                        :isSentMsg="sent_chatlog_id.includes(msg.id)"
                        :quoteMessageId="msg.quoted_message_id"
                        @reply="onReply(msg)"
                        :senderId="chatView.senderId"
                        :botCode="chatView.botCode"
                    ></Message>
                </div>
            </div>
            <div class="friend-sell" :class="{active: !!rssActive}" v-if="shouldShowRss" :style="`height: ${friendSellHeight}px`">
                <div class="friend-sell-header" :class="{'remove-right-padding': !rssActive}">
                    <div class="rss-category" >
                        <div>
                            <v-menu top nudge-top="25">
                                <template v-slot:activator="{on}">
                                    <div v-on="on">
                                        {{ rssSource === 'fpt' ? 'FPT Play' : 'VN Express '}}
                                        <v-icon small>mdi-chevron-up</v-icon>
                                    </div>
                                </template>
                                <v-list>
                                    <v-list-tile @click="rssSource = 'fpt'">FPT Play</v-list-tile>
                                    <v-list-tile @click="rssSource = 'vne'">VN Express</v-list-tile>
                                </v-list>
                            </v-menu>
                        </div>
                        <div v-for="(list, i) in rssData" :key="i" @click="openRss(i)" :class="{active: i === rssActive}">
                            {{ i }}
                        </div>
                    </div>
                    <v-icon class="hide-rss" @click="openRss(null)" v-if="!!rssActive">mdi-chevron-down</v-icon>
                </div>
                <div class="friend-sell-body" v-if="!!rssActive">
                    <div v-for="(item, i) in rssData[rssActive]" :key="i" class="item">
                        <v-tooltip bottom>
                            <template v-slot:activator="{on}">
                                <div class="item-img" :style="'background-image: url('+item.img+')'" v-on="on"></div>
                                <div class="item-title" v-on="on">{{ item.title }}</div>
                            </template>
                            <span>
                                {{ item.description }}
                            </span>
                        </v-tooltip>
                        <div>
                            <v-btn outline class="mx-0 friend-sell-btn" small @click="sendRss(item)">
                                <span style="color: #888A9A; margin-right: 5px">Send</span>
                                <v-icon color="#888A9A" small>mdi-send-circle</v-icon>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
          <div class="chatview-footer" v-if="!botConfig.limitUsageStatus || botConfig.limitUsageStatus.unlimited_usage || !botConfig.limitUsageStatus.limit_exceeded">
                <div class="assign-action" v-if="(botStatus || !supporter || (isBotLeader && me.id !== supporter.id))">
                  <v-btn :color="(!!(supporter && supporter.id) || !chatView.customer.need_support) ? '' : '#0052CC'"
                         v-if="botConfig['enableChangeRequestSupport'] === '1' && isBotLeader && !currentCustomer.block_status"
                         :disabled="!!(supporter && supporter.id) || !chatView.customer.need_support"
                         :dark="!(!!(supporter && supporter.id) || !chatView.customer.need_support)"
                         @click="openDialogChangeRequestSupport">
                    <v-icon class="mr-2">mdi-pencil</v-icon>
                    {{ $t('changeRequest')|capitalizeAll }}
                  </v-btn>
                  <v-btn color="#F7722F" dark @click="assignTo(true)" v-if="!currentCustomer.block_status">
                    <img src="/icon/assign_to_me.svg" alt="icon" class="mr-2">
                    {{ $t('assignToMe') }}
                  </v-btn>
                  <v-btn color="#0052CC" dark @click="assignTo(false)" v-if="isBotLeader && !currentCustomer.block_status">
                    <img src="/icon/assign_to.svg" alt="icon" class="mr-2">
                    {{ $t('assignTo') }}
                  </v-btn>
                </div>
                <div class="support-action" v-show="!botStatus && me && supporter && me.id === supporter.id">
                  <div class="action-viewport">
                    <div class="chat-input">
                      <div class="file-viewport" v-if="file || image">
                        <div class="file-item" v-if="file">
                          <v-icon size="24" color="#888A99" class="px-2">mdi-file-document-outline</v-icon>
                          <span class="file-name">{{file.name}}</span>
                          <v-btn icon small @click="file=null" color="white">
                            <v-icon size="16" color="#888A99" class="px-2">mdi-close</v-icon>
                          </v-btn>
                        </div>
                        <div class="image-item" :style="`background-image: url(${pastedImageUrl})`" v-if="image">
                          <v-btn small icon color="white" @click="image=null">
                            <v-icon size="16">mdi-close</v-icon>
                          </v-btn>
                        </div>
                      </div>
                      <v-form @submit.prevent="submit" style="background-color: white">
                        <div class="row quote-message"  v-if="quoted_message||quoteMessages[chatView.senderId]" style="padding: 12px 0 0 12px;background-color: white;position: relative">
                          <Message
                              style="width:fit-content;border-left: #1976d2 solid 5px;padding:5px;margin: 5px; box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;border-radius: 5px"
                              :message="quoted_message||quoteMessages[chatView.senderId]"
                              :customer="customer"
                              :showClose="true"
                              @close="removeQuoteMessage"
                          ></Message>
                        </div>
                        <v-textarea
                                  id="chat-input-txt"
                                  v-model="message"
                                  :placeholder="$t('typeMessage')"
                                  @keypress.enter.exact.prevent="submit"
                                  @paste="onPaste"
                                  rows="1" auto-grow
                                  hide-details
                                  flat solo
                                  ref="message"></v-textarea>
                      </v-form>
                    </div>
                    <div class="chat-action">
                      <v-tooltip top>
                        <template v-slot:activator="{on}">
                          <v-btn icon small @click.native="$refs.file.click()" v-on="on">
                            <v-icon size="16">mdi-attachment</v-icon>
                          </v-btn>
                        </template>
                        <span>Attachment</span>
                      </v-tooltip>
                      <emoji-picker @select="onSelectEmoji" :nudge-right="250">
                        <template v-slot:activator="{ onClick }">
                          <v-btn icon small v-on="{ click: onClick }">
                            <v-icon size="16">mdi-emoticon-happy-outline</v-icon>
                          </v-btn>
                        </template>
                      </emoji-picker>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon small  v-on="on">
                            <v-icon size="16" :color="showAgentQuickResponse ? '#ED9E4F' : '#0052CC'" @click="toggleAgentQuickResponse">mdi-message-processing</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('quickResponse') | capitalize }}</span>
                      </v-tooltip>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn small icon @click="assignTo(false)" v-on="on">
                            <v-icon color="#FF5F5F" size="16">mdi-arrow-right-bold-circle</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('forwardTo') }}</span>
                      </v-tooltip>
                      <ToggleStaffChat></ToggleStaffChat>
                      <v-spacer/>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn small icon @click="submit" v-on="on">
                            <v-icon color="#0052CC" size="16">mdi-send-outline</v-icon>
                          </v-btn>
                        </template>
                        <span>{{ $t('sendMessage') }}</span>
                      </v-tooltip>
                    </div>
                  </div>
                </div>
                <div v-if="user_inactive_24h || showScrollBottom" class="user-inactive-container">
                    <div v-if="user_inactive_24h" class="user-inactive" @click="user_inactive_24h = false">
                        {{ $t('userInactive24h') }}
                        <v-icon class="ml-2" color="#fff" small>mdi-close</v-icon>
                    </div>
                    <div v-if="showScrollBottom" class="latest-message"
                        @click="showScrollBottom = false; scrollBottom();">
                        <v-icon small color="#fff" class="mr-2">mdi-arrow-down</v-icon>
                        {{$t('latestMessage') | capitalize}}
                    </div>
                </div>
            <AgentQuickResponse v-if="showAgentQuickResponse" @select="onAgentQuickResponse"/>
            </div>
        </template>
        <v-layout v-else justify-center align-center style="height: 100%; color: #B5B5B5;">
            {{ $t('chooseSenderMessage') }}
        </v-layout>
        <DialogSendConversationToEmail ref="SendConversationToEmailDialog"></DialogSendConversationToEmail>
        <input
            ref="file"
            onclick="this.value=null;"
            @change="onChangeFile"
            hidden
            type="file" name="upload_file"
            accept="image/jpeg,image/png,image/gif,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
        />
    </div>
</template>
<script>
import socketHandler from '../services/socket_handlers/socket_handlers.js';
import messageHandler from '../services/message_handlers/supporter_handler_message.js';
import customerService from '../services/customer.service';
import {mapActions, mapMutations, mapState} from 'vuex'
import BotService from "../services/bot.service";
import StaffService from "../services/staff.service";
import moment from "moment";
import {storage} from '../utils/map';
import utils from '../services/utils';
import supporter_handler_message from "../services/message_handlers/supporter_handler_message";
import $const from "../utils/const";
import * as _ from "lodash";
import Message from "components/message-box/content/Message";
import SystemMessage from "components/message-box/system-message/SystemMessage";
import RSSService from "@/services/rss.service";
import DialogSendConversationToEmail from "@/components/dialog/DialogSendConversationToEmail";
import ToggleStaffChat from "./custom/ToggleStaffChat";
import i18n from "../plugins/i18n";
import AgentQuickResponse from "./menu-box/AgentQuickResponse";
import ActionTypes from "@/store/ActionTypes";
import Vue from "vue";

const ChatLogSource = {
    RECEIVE: 1,  // tin nhắn nhận từ người dùng
    SEND: 2,  // tin nhắn từ hệ thống gửi cho người dùng
};
const MessageSource = {
    NORMAL: 1,  // Tin nhắn bình thường ngời dùng vs bot, bot vs ng
    SYSTEM: 2,  // Tin nhắn từ hệ thống tới người dùng (broadcast) -> Deprecated
    ADMIN: 3,  // Admin gửi tin nhắn đến người dùng, người dùng chat với admin
    SEND_BROADCAST: 4,  // Send broadcast
    SEND_REMINDER: 5,  // Send reminder
    CALL_SEND_MESSAGE_API: 6,  // Send message controllers
};

export default {
    name: "ChatView",
    components: {
        DialogSendConversationToEmail,
        Message,
        SystemMessage,
        ToggleStaffChat,
        AgentQuickResponse,
    },
    data () {
        return {
            chatLog: [],
            message: '',
            file: null,
            image: null,
            scSubscribeChannel: null,
            isBotLeader: false,
            isAssignView: false,
            // load chatlogs
            displayLoadingChatlogs: false,
            paramsLoadChatLogs: '',
            canLoadMoreChatLogs: false,
            scrollPosition: 0,
            me: StaffService.getMe() ? StaffService.getMe() : {},
            shouldLoadChatLogOnScroll: false,

            // conversation with admin
            // canSendEmailConversation: false,
            displaySupporterConversation: false,

            // upload file
            uploadFileContent: null,

            // loading

            user_inactive_24h: true,

            last_user_seen_time: null,
            last_user_seen_message: null,
            sent_chatlog_id: [],
            accept_message_types: utils.viewableMessageType,
            showScrollBottom: false,
            shouldShowRss: false,
            rssData: {},
            rssSource: 'vne',
            rssActive: null,
            headerHeight: 60,
            friendSellSmallHeight: 27,
            friendSellBigHeight: 315,
            last_mark_typing: 0,
            quickReplyTemplate: null,
            quoted_message: null,
        }
    },
    mounted() {
      this.$EventBus.$on(this.$EventBusType.ON_SELECT_SUGGESTION, this.onAgentSelectSuggestion)

        // // init logging client status
        // if (!this.$store.state.loggingInterval) {
        //     let _this = this;
        //     // console.log('init logging client status');
        //     this.$store.state.loggingInterval = setInterval(() => {
        //         try {
        //             // console.log('start logging client status')
        //             let { bot_code } = _this.$route.params;
        //             let botCode = _this.chatView.botCode || bot_code;
        //             let status = null;
        //             let subscribed_channels = null;
        //             if (_this.$store.state.scClient) {
        //                 status = _this.$store.state.scClient.getState();
        //                 subscribed_channels = _this.$store.state.scClient.subscriptions(false);
        //             }
        //             let js_heap_size_limit = window.performance.memory.jsHeapSizeLimit;
        //             let used_js_heap_size = window.performance.memory.usedJSHeapSize;
        //             let total_js_heap_size = window.performance.memory.totalJSHeapSize;

        //             let url = `/live-support/log-agent-client-status/${botCode}/`;
        //             // console.log('logging client status');
        //             // console.log(url, status, subscribed_channels, used_js_heap_size, js_heap_size_limit, total_js_heap_size);

        //             _this.$http.post(url, {
        //                 "socket_status": status,
        //                 "socket_subscribed": subscribed_channels,
        //                 "js_heapsize_used": used_js_heap_size,
        //                 "js_heapsize_limit": js_heap_size_limit,
        //                 "js_heapsize_total": total_js_heap_size,
        //             })
        //         } catch (_e) {
        //             // console.log('logging client status error')
        //             // console.log(e);
        //         }

        //     }, 60000);
        // }
    },
  computed: {
        ...mapState(['notifyStaffChat', 'isSmallScreen', 'chatView', 'botStatus', 'supporter', 'messageCache', 'countOpeningTicket', 'bot', 'notifyBotChat', "quoteMessages"]),
        ...mapState('ticket', ['countOpening']),
        ...mapState('config', ['botConfig']),
        ...mapState('customer', ['currentCustomer', 'overview']),
        ...mapState('agentQuickResponse', ['showAgentQuickResponse', 'listResponseTemplate']),
        ...mapState('crm', ['crmData']),
        pastedImageUrl() {
          return this.image ? URL.createObjectURL(this.image) : ""

        },
        blockStatus() {
          return this.currentCustomer.block_status
        },
        customer () {
            return {
                name: this.chatView.customer.sender_name,
                image: this.chatView.customer.image
            }
        },
        canSendEmailConversation () {
            let storageEmail = this.botConfig && this.botConfig["emailConversationConfig"] ? this.botConfig["emailConversationConfig"] : [];
            return (storageEmail && storageEmail.length > 0 && !this.botStatus && this.supporter && this.supporter.id > 0)
        },
        canBlockCustomer() {
            let isSupporterLead = StaffService.checkStaffHasRole(this.chatView.botCode, this.me.id, [10, 9, 5])
            return (this.botConfig["agentAllowBlockSender"] || isSupporterLead);
        },
        chatLogsSortByTime () {
            return _.sortBy(this.chatLog, ['created_time'])
        },
        friendSellHeight () {
            if (this.shouldShowRss) {
                return  this.rssActive ? this.friendSellBigHeight : this.friendSellSmallHeight
            }
            return 0
        },
        chatSupporter () {
            if (this.botStatus) {
                return {
                    text: 'BOT',
                    color: '#19AB66'
                }
            }
            if (this.supporter) {
                return {
                    text: this.$filters.capitalize(this.$t('agentSupport')),
                    color: '#F7B92F'
                }
            }
            return {
                text: this.$filters.capitalize(this.$t('botOffNeedSupport')),
                color: '#E53737'
            }
        }
    },
    beforeDestroy () {
        this.$EventBus.$off(this.$EventBusType.ON_SELECT_SUGGESTION)
        if (this.$refs.content) {
            this.$refs.content.removeEventListener('scroll', this.eventScrollChatlogs);
        }
    },
    methods: {
        ...mapMutations('sideBox', ['toggleSessionInfo', 'toggleNotes', 'toggleMarkAsDone', 'toggleTicket', 'toggleAssignSupporter']),
        ...mapActions('dialog', ['openDialogBlockCustomer', 'openDialogChangeRequestSupport']),
        ...mapActions('loading', ['openLoading', 'closeLoading']),
        ...mapActions('agentQuickResponse', ['toggleAgentQuickResponse', 'onUseTemplate']),
        ...mapActions('crm', ['getAllCustomerAttributes']),
        onAgentSelectSuggestion(message) {
          this.message += message;
        },
        async onPaste(event) {
          const items = (event.clipboardData  || event.originalEvent.clipboardData).items;
          const text = (event.clipboardData  || event.originalEvent.clipboardData).getData("text/plain")
          // Process image
          let blob = null;
          for (let i = 0; i < items.length; i++) {
            if (items[i].type.indexOf("image") === 0) {
              blob = items[i].getAsFile();
            }
          }
          // load image if there is a pasted image
          if (blob !== null && !text) {
            this.image = blob;
            this.$store.commit(ActionTypes.MESSAGE_CACHE, {sender_id: this.chatView.senderId, image: this.image})
          }
        },
        onSelectEmoji(emoji) {
          this.message += emoji
        },
        goToBotList() {
            let { bot_code } = this.$route.params;
            this.$router.push(`/bot/${bot_code}/`);
        },
        isUser (msg) {
            return msg.source === ChatLogSource.RECEIVE
        },
        isBot (msg) {
            return msg.sender_type !== MessageSource.ADMIN && msg.source === ChatLogSource.SEND
        },
        isAdmin (msg) {
            return msg.sender_type === MessageSource.ADMIN && msg.source === ChatLogSource.SEND
        },
        startNewChat () {
            this.getBotStatus();
            this.connectSocket();
            this.shouldLoadChatLogOnScroll = false;
            this.$nextTick(() => {
                let element = this.$refs.content;
                if (!element.hasAttribute('scroll')) {
                    element.addEventListener('scroll', this.eventScrollChatlogs);
                }
            });
        },
        scrollBottom () {
            let element = this.$refs.content;
            element.setAttribute('style', 'scroll-behavior: auto;');
            element.scrollTop = element.scrollHeight - element.clientHeight;
            element.setAttribute('style', `scroll-behavior: smooth;`);
        },
        onAgentQuickResponse(item) {
          this.quickReplyTemplate = Object.assign({sender_id: this.chatView.senderId, channel: this.chatView.customer.sender_channel}, item);
          this.message = item.content.format(this.crmData);
          this.toggleAgentQuickResponse()
        },
      submit () {
            if (this.image) {
              this.sendAttachment(this.image)
              this.image = null
            }
            if (this.file) {
              this.sendAttachment(this.file)
              this.file = null
            }
            if (this.message.trim() !== "") {
                let JWT_KEY = 'fptai_messenger_user_jwt';
                let JWToken = "";
                if (storage.has(JWT_KEY)) {
                    JWToken = storage.getItem(JWT_KEY).user_token
                }
                let payload = {text: this.message.trim()}
                let quoted = this.getQuoted();
                if (quoted?.id) {
                  payload.quoted_message_id = quoted?.id;
                  this.removeQuoteMessage();
                }
                messageHandler.send_message_to_socket(
                    'text',
                    this.chatView.senderId,
                    this.chatView.customer.sender_name,
                    this.chatView.botCode,
                    this.chatView.customer.sender_channel,
                    payload,
                    JWToken,
                    "admin",
                    this.me
                )
                this.last_mark_typing = 0;
            }
            if (this.quickReplyTemplate) {
              this.onUseTemplate(this.quickReplyTemplate)
            }
              this.message = ""
              //Reset height
              this.$refs.message.$refs.input.style.height = "38px"
              this.quickReplyTemplate = null
              this.$store.commit(this.$ActionTypes.DEL_MESSAGE_CACHE, this.chatView.senderId)
        },
        async connectSocket () {
            if (this.$store.state.scClient && this.chatView.customer) {
                // check subscribed > unsubscribe
                if (this.scSubscribeChannel && this.scSubscribeChannel.state && this.scSubscribeChannel.state === 'subscribed') {
                    this.scSubscribeChannel.destroy();
                }

                this.scSubscribeChannel = socketHandler.subscribe_users_channel(
                    this.chatView.botCode,
                    this.chatView.senderId,
                    this.$store.getters.channel
                );
                if (this.scSubscribeChannel) {
                    this.chatLog = [];

                    // get chatlog of this sender
                    await this.getChatLogs(this.chatView.senderId, this.chatView.botCode);
                    this.scrollBottom();

                    this.$nextTick(() => {
                        let _this = this;
                        this.scSubscribeChannel.watch(data => {
                            if (this.currentCustomer.block_status) {
                              return;
                            }
                            if (!this.$refs.content) {
                                return;
                            }
                            if (data.source === "system") {
                                if (data.type === "user_seen_message") {
                                    //{ type: "user_seen_message", timestamp: 1595997356336, source: "system" }
                                    let timestamp = moment(data.timestamp).add(1, "seconds").toDate()
                                    if (timestamp > this.last_user_seen_time) {
                                        this.last_user_seen_time = timestamp;
                                        for (let i = (this.chatLog.length - 1); i >= 0; i--) {
                                            if (this.check_last_seen_message(this.chatLog[i])) {
                                                break;
                                            }
                                        }
                                    }
                                } else if (data.type === "message_send_fail" && data.chatlogs_send_fail && data.chatlogs_send_fail.length > 0) {
                                    for (let fail_chatlog of data.chatlogs_send_fail) {
                                        for (let i = (this.chatLog.length - 1); i >= 0; i--) {
                                            if (fail_chatlog.id === this.chatLog[i].id) {
                                                this.chatLog[i].status = -1;
                                                this.chatLog[i].error_message = fail_chatlog.error_message;
                                                break;
                                            }
                                        }
                                    }
                                } else if (data.type === "update_chatlog_id") {
                                    let old_id = data.old_id, new_id = data.new_id;
                                    if (!old_id || !new_id) return;
                                    for (let i = (this.chatLog.length - 1); i >= 0; i--) {
                                        if (old_id === this.chatLog[i].id) {
                                            this.chatLog[i].id = new_id;
                                            break;
                                        }
                                    }
                                } else if (data.type === "message_resend") {
                                    let chatlog_id = data.chatlog_id;
                                    if (!chatlog_id) return;
                                    for (let i = (this.chatLog.length - 1); i >= 0; i--) {
                                        if (chatlog_id === this.chatLog[i].id) {
                                            this.chatLog[i].status = 1;
                                            this.chatLog[i].error_message = "";
                                            break;
                                        }
                                    }
                                } else if (data.type === "message_sent") {
                                    this.sent_chatlog_id = (data.chatlog_ids && data.chatlog_ids instanceof Array) ? data.chatlog_ids : [];
                                } else if (data.type === "chatlog_system_notes" && data.chatlog_system_notes && data.chatlog_system_notes.length > 0) {
                                    for (let log of data.chatlog_system_notes) {
                                        log.sender_type = log.type;
                                        log.supporter = log.extra;
                                        log.first_session = false;
                                        let log_message = { ...JSON.parse(log.message) }
                                        for (let key of Object.keys(log_message)) {
                                            if (key !== "source") {
                                                log[key] = log_message[key];
                                            }
                                        }
                                        _this.handler_chatlog_msg(log);
                                        _this.$nextTick(() => {
                                            let el = _this.$refs.content;
                                            el.scrollTop = el.scrollHeight - el.clientHeight;
                                        })

                                    }
                                }
                            } else {
                                _this.handler_socket_msg(data)
                            }
                        })
                    });
                }
            }
        },
        handler_socket_msg (msg) {
            // Handler msg for each channel to display
            let acceptMsg = messageHandler.handler_message(msg, this.$store.getters.channel);
            if (this.supporter && this.supporter.id === this.me.id) {
              acceptMsg.sender_type = 3;
            }
            this.check_last_seen_message(acceptMsg)

            if (acceptMsg.source === ChatLogSource.RECEIVE) {
                this.user_inactive_24h = false;
                this.mark_seen();
            }

            // check is first/last msg
            acceptMsg.isLastMsg = true;
            let lengthMsg = this.chatLog.length;
            if (lengthMsg > 0) {
                acceptMsg.isFirstMsg = acceptMsg.source !== this.chatLog[lengthMsg - 1].source;
                if (acceptMsg.source === this.chatLog[lengthMsg - 1].source) {
                    this.chatLog[lengthMsg - 1].isLastMsg = false;
                }
            } else {
                acceptMsg.isFirstMsg = true;
            }

            // check file id to remove message uploading id
            if (acceptMsg.type === $const.MSG_TYPE.FILE) {
                if (acceptMsg.content && acceptMsg.content.file_id) {
                    let msg_file_id = acceptMsg.content.file_id;
                    for (let i = 0; i < this.chatLog.length; i++) {
                        if (this.chatLog[i].type === 'uploading' && this.chatLog[i].id === msg_file_id) {
                            this.chatLog.splice(i, 1);
                            break;
                        }
                    }
                }
            }

            // check created time to push msg to right position
            if (this.chatLog.length > 0) {
                // check created time to push msg to right position
                for (let i = this.chatLog.length - 1; i >= 0; i--) {
                    let new_msg_time = new Date(acceptMsg.created_time);
                    let compare_time = new Date(this.chatLog[i].created_time);
                    if (new_msg_time > compare_time) {
                        this.chatLog.splice(i + 1, 0, acceptMsg);
                        break;
                    } else if (i === 0) {
                        this.chatLog.splice(i, 0, acceptMsg);
                        break;
                    }
                }
            } else {
                this.chatLog.push(acceptMsg);
            }

            //showScrollBottom if user is viewing something
            let supporter = null
            if (acceptMsg.sender_type === MessageSource.ADMIN && acceptMsg.source === ChatLogSource.SEND) {
                supporter = JSON.parse(acceptMsg.supporter)
            }
            let element = this.$refs.content
            let maxScrollTop = element.scrollHeight - element.clientHeight
            if (
                (supporter && supporter.admin.email === this.$store.state.user.email)
                || (maxScrollTop - 5 <= element.scrollTop)
            ) {
                this.$nextTick(this.scrollBottom);
            } else {
                this.showScrollBottom = true
            }

            // call API send notify seen msg
            if (!this.supporter || this.supporter && (this.supporter.id === this.me.id) || this.supporter.name === "BOT") {
                customerService.sendStatusSeenCustomerMessage(this.chatView.botCode, this.chatView.senderId);
            }
        },

        handler_chatlog_msg (msg) {
            let acceptMsg = messageHandler.handler_message(msg, this.$store.getters.channel);
            acceptMsg.isLastMsg = true;
            let lengthMsg = this.chatLog.length;
            if (lengthMsg > 0) {
                acceptMsg.isFirstMsg = acceptMsg.source !== this.chatLog[lengthMsg - 1].source
                if (acceptMsg.source === this.chatLog[lengthMsg - 1].source) {
                    this.chatLog[lengthMsg - 1].isLastMsg = false;
                }
            } else {
                acceptMsg.isFirstMsg = true;
            }
            this.check_last_seen_message(acceptMsg);
            this.chatLog.unshift(acceptMsg);
        },

        check_last_seen_message (message) {
            try {
                if (this.last_user_seen_time && message.source === ChatLogSource.SEND && this.accept_message_types.includes(message.type)) {
                    let created_time = new Date(message.created_time);
                    if (this.last_user_seen_time >= created_time) {
                        if (!this.last_user_seen_message) {
                            this.last_user_seen_message = message;
                            this.last_user_seen_message.last_created_time = created_time;
                            return true;
                        } else if (this.last_user_seen_message.last_created_time <= created_time) {
                            this.last_user_seen_message = message;
                            this.last_user_seen_message.last_created_time = created_time;
                            return true;
                        }
                    }
                }
            } catch (e) {

            }
            return false;
        },

        async getChatLogs (senderId, botCode, urlLoad = '') {
            let url = `/live-support/get-admin-chatlog/${botCode}/${senderId}/`;
            if (urlLoad !== '') {
                url = urlLoad;
                url = urlLoad.replace('/backend/api/v1', '');
            } else if (this.displaySupporterConversation) {
                url += '?cs_only=true';
            }
            await this.$http.get(url).then(
                response => {
                    let last_session_id = '';
                    // check last session id
                    if (this.chatLog.length > 0) {
                        last_session_id = this.chatLog[0].session_id;
                    }
                    let prevLog = null;
                    for (let log of response.data.chatlog) {
                        if (log.message_type !== "request_human_support" && log.message_type !== "typing") {
                            let is_first_session = false;
                            if (!log.session_id && prevLog) {
                                log.session_id = prevLog.session_id
                            }
                            if (last_session_id === '' && log.session_id !== '') {
                                last_session_id = log.session_id;
                                is_first_session = true;
                            } else if (last_session_id !== '' && log.session_id !== '' && last_session_id !== log.session_id) {
                                last_session_id = log.session_id;
                                is_first_session = true;
                            }
                            this.$store.dispatch(this.$ActionTypes.LAST_SESSION_ID, last_session_id);
                            if (this.chatLog.length > 0) {
                                this.chatLog[0].first_session = is_first_session;
                            }

                            log.sender_type = log.type;
                            log.supporter = log.extra;
                            log.first_session = false;
                            let log_message = { ...JSON.parse(log.message) }
                            for (let key of Object.keys(log_message)) {
                                if (key !== "source") {
                                    log[key] = log_message[key];
                                }
                            }
                            this.handler_chatlog_msg(log)
                            prevLog = log
                        }
                    }

                    // console.log(this.chatLog);
                    this.$nextTick(this.scrollBottom);
                    this.paramsLoadChatLogs = response.data.next ? response.data.next : '';
                    this.canLoadMoreChatLogs = this.paramsLoadChatLogs !== '';
                    // check if fisrt message of user
                    if (!this.canLoadMoreChatLogs && this.chatLog.length > 0) {
                        this.chatLog[0].first_session = true
                    }
                    this.shouldLoadChatLogOnScroll = true;
                },
                this.$AppService.handleRequestError('can not load chat history')
            );
        },
        getBotStatus () {
            BotService.getBotStatus(this.chatView.senderId, this.chatView.botCode).then(
                result => {
                    this.$store.commit(this.$ActionTypes.BOT_STATUS, result.data.status);
                    // this.$store.commit(
                    //     this.$ActionTypes.SUPPORTER,
                    //     result.data.status ? this.$const.BOT_SUPPORTER : result.data.supporter
                    // );
                    this.chatView.livesupport_log = result.data.livesupport_log;
                    this.$forceUpdate();
                    this.mark_seen();
                },
                this.$AppService.handleRequestError()
            );
        },
        setBotStatus () {
            BotService.setBotStatus(this.chatView.senderId, this.chatView.botCode, this.botStatus).then(
                result => {
                    this.botStatus = result.data.status
                },
                this.$AppService.handleRequestError('can not set bot status')
            )
        },
        assignTo (isMe, ignore_max_supporting = false) {
            if (isMe) {
                let me = StaffService.getMe();
                StaffService.assignTo(me.id, this.chatView.livesupport_log, ignore_max_supporting).then(
                    (response) => {
                        if (response.data && response.data.livesupport_log) {
                            this.chatView.livesupport_log = response.data.livesupport_log;
                        }
                        if(response.data && response.data.app_sender.supporter) {
                            this.$store.commit(this.$ActionTypes.SUPPORTER,  response.data.app_sender.supporter);
                            this.$store.commit(this.$ActionTypes.BOT_STATUS,  false);
                            if (this.$store.state.viewBotView) {
                                this.$store.state.viewBotView.adminAssignSupport({data: {sender_id:this.chatView.senderId, app_sender: response.data.app_sender}})
                            }
                        }

                    },
                    (e) => {
                        if (e.response && e.response.status === 423) {
                            this.$AppService.toastError(this.$t('assignLocked'));
                            BotService.getBotStatus(this.chatView.senderId, this.chatView.botCode).then(
                                result => {
                                    this.$store.commit(this.$ActionTypes.BOT_STATUS, result.data.status);
                                    // this.$store.commit(
                                        // this.$ActionTypes.SUPPORTER,
                                        // result.data.status ? this.$const.BOT_SUPPORTER : result.data.supporter
                                    // );
                                    this.chatView.livesupport_log = result.data.livesupport_log;
                                },
                                this.$AppService.handleRequestError()
                            );
                        } else if (e.response && e.response.status === 400 && e.response.data && e.response.data.message === "over supporting limit") {
                            let supporting_count = e.response.data.supporting_count
                            this.$appService.confirm(this.$t('tooManySupportingAssignToMe', [supporting_count])).then(confirm => {
                                if (confirm === true) {
                                    this.assignTo(isMe, true);
                                }
                            })
                        } else {
                            this.$AppService.handleRequestError('Can not assign to ' + this.activeStaff.name)
                        }
                    }
                )
            } else {
                this.toggleAssignSupporter()
            }
        },
        async eventScrollChatlogs () {
            if (this.shouldLoadChatLogOnScroll) {
                let objChatBox = this.$refs.content;
                if (objChatBox.scrollTop === 0) {
                    if (this.canLoadMoreChatLogs) {
                        this.scrollPosition = objChatBox.scrollHeight;
                        this.displayLoadingChatlogs = true;
                        await this.getChatLogs(this.chatView.senderId, this.chatView.botCode, this.paramsLoadChatLogs);
                        this.$nextTick(function () {
                            this.displayLoadingChatlogs = false;
                            // scroll
                            objChatBox.setAttribute('style', 'scroll-behavior: auto;');
                            objChatBox.scrollTop = objChatBox.scrollHeight - this.scrollPosition - 22;
                            objChatBox.setAttribute('style', 'scroll-behavior: smooth;');
                        });

                    }
                }
            }
        },

        formatDateTime (value) {
            if (!value) return '';
            return moment.utc((value)).local().format('DD-MM-YYYY HH:mm')
        },
        showSupporterConversation () {
            this.chatLog = [];
            this.shouldLoadChatLogOnScroll = false;
            this.displaySupporterConversation = !this.displaySupporterConversation;
            this.getChatLogs(this.chatView.senderId, this.chatView.botCode).then(() => {
              this.scrollBottom()
              this.shouldLoadChatLogOnScroll = true;
            });
        },
        open_sendEmailConversation_dialog () {
            console.log(this.currentCustomer);
            const emailTitle = `${i18n.t('emailConversation.title', [this.bot.name, this.supporter.name, this.currentCustomer.sender_name, this.currentCustomer.sender_id_ai, this.currentCustomer.sender_channel])}`
            this.$refs.SendConversationToEmailDialog.open(
                this.chatView.botCode,
                this.chatView.senderId,
                this.chatView.livesupport_log ? this.chatView.livesupport_log : {},
                emailTitle
            )
        },
        onChangeFile(event) {
          this.file = event.target.files[0];
          this.$store.commit(ActionTypes.MESSAGE_CACHE, {sender_id: this.chatView.senderId, file: this.file})
        },
        sendAttachment (file) {
            if (file) {
                let extFile = file.name.split('.').pop().toLowerCase();
                if (this.$const.ALLOW_ATTACHMENT_EXTENSION.indexOf(extFile) < 0) {
                    // 'File upload is not allow!!'
                    this.$AppService.toast(
                        "File upload is not allow!!",
                        'error',
                        5000
                    );
                    return false;
                }
                // file size
                let fileSize = file.size / 1024 / 1024;
                // max size allow ~10Mb
                if (fileSize > 10) {
                    // 'File upload is too big!!'
                    this.$AppService.toast(
                        "File upload is too big!!",
                        'error',
                        5000
                    );
                    return false;
                }

                // create new file ID
                let new_file_id = utils.render_random_id();
                // Add file uploading msg to list message
                let msgUploading = {
                    id: new_file_id,
                    supporter: JSON.stringify({ "admin": StaffService.getMe() }),
                    content: { "status": "uploading", "file_name": file.name },
                    session_id: this.chatLog.length > 0 ? this.chatLog[this.chatLog.length - 1].session_id : "",
                    sender_type: 3,
                    source: 2,
                    type: "uploading",
                    created_time: (new Date()).toGMTString()
                };

                this.chatLog.push(msgUploading);
                this.$nextTick(this.scrollBottom);

                // call api upload file
                supporter_handler_message.send_file_to_customer(this.chatView.botCode, this.chatView.senderId, this.chatView.customer.sender_channel, new_file_id, file, function (success) {
                    // console.log(success);
                    if (!success) {
                        // upload file > show error
                        for (let iu = 0; iu < this.chatLog.length; iu++) {
                            if (this.chatLog[iu].id === new_file_id) {
                                this.chatLog[iu].content.status = "failed";
                                break;
                            }
                        }
                    }
                }.bind(this));

            }
        },
        contentScroll () {
            let element = this.$refs.content;
            let maxScrollTop = element.scrollHeight - element.clientHeight
            if (maxScrollTop - 5 <= element.scrollTop) {
                this.showScrollBottom = false
            }
        },
        openRss (name) {
            this.rssActive = name
        },
        sendRss (item) {
            let JWT_KEY = 'fptai_messenger_user_jwt';
            let JWToken = "";
            if (storage.has(JWT_KEY)) {
                JWToken = storage.getItem(JWT_KEY).user_token
            }
            messageHandler.send_message_to_socket(
                'zalo_list_template',
                this.chatView.senderId,
                this.chatView.customer.sender_name,
                this.chatView.botCode,
                this.chatView.customer.sender_channel,
                {
                    "title": item.title,
                    "sub_title": item.description,
                    "url": item.img,
                    "buttons": [
                        {
                            "title": "Xem chi tiết",
                            "image_url":"https://cdn-static-v3.fpt.ai/upload/8c3f4b0a6bc56867354e30132fa10c31/b1861f80e50cefa3ae358b4d2993437c.jpg",
                            "url": item.link
                        }
                    ]
                },
                JWToken,
                "admin",
                this.me
            )
            this.rssActive = null
            setTimeout(() => {
                this.scrollBottom()
            }, 500)
        },
        updateRss() {
            if (this.$route.params.bot_code) {
                this.rssData = []
                BotService.getBotConfigSuggestHobby(this.$route.params.bot_code).then(
                    result => {
                        if (result.data) {
                            this.shouldShowRss = true
                            RSSService.getData(this.rssSource).then(
                                data => {
                                    this.rssData = data
                                }
                            )
                        } else {
                            this.shouldShowRss = false
                            this.rssData = []
                        }
                    }
                )
            }
        },
        mark_seen() {
            if (!this.botStatus && this.me && this.supporter && this.me.id === this.supporter.id) {
                BotService.mark_seen(this.chatView.botCode, this.chatView.senderId).catch(e => {
                    console.error("mark seen failed", e);
                })
            }
        },
        mark_typing() {
            let _now = moment().unix();
            if (!!this.chatView.botCode && !!this.chatView.senderId && !this.botStatus && this.me && this.supporter && this.me.id === this.supporter.id && (_now - this.last_mark_typing) >= 20) {
                this.last_mark_typing = _now;
                BotService.mark_typing(this.chatView.botCode, this.chatView.senderId).catch(e => {
                    console.error("mark typing failed", e);
                })
            }
        },
        mark_typing_off() {
            setTimeout(() => {
                if (!!this.chatView.botCode && !!this.chatView.senderId && !this.botStatus && this.me && this.supporter && this.me.id === this.supporter.id && !(this.message && this.message.length > 0)) {
                    BotService.mark_typing_off(this.chatView.botCode, this.chatView.senderId).catch(e => {
                        console.error("mark typing failed", e);
                    }).finally(() => {
                        this.last_mark_typing = 0;
                    })
                }
            }, 3000);
        },
      getQuoted(){
        return this.quoted_message|| this.quoteMessages[this.chatView.senderId];
      },
      onReply(msg){
          let quoted_message =  JSON.parse(JSON.stringify(msg));
          quoted_message.sender_id = this.chatView.senderId;
          if (quoted_message?.content.text.length > 100) {
            quoted_message.content.text = quoted_message.content.text.substr(0,100) + ' ...';
          }
          this.$store.commit(this.$ActionTypes.QUOTE_MESSAGE, quoted_message)
          this.quoted_message= quoted_message;
      },
      removeQuoteMessage() {
        this.$store.commit(this.$ActionTypes.DEL_QUOTE_MESSAGE, {sender_id: this.chatView.senderId});
        this.quoted_message=null;
      }
    },
    watch: {
        chatView () {
            if (this.chatView.senderId) {
                this.message = this.messageCache[this.chatView.senderId]?.message || '';
                this.file = this.messageCache[this.chatView.senderId]?.file || null;
                this.image = this.messageCache[this.chatView.senderId]?.image || null;
                this.startNewChat();
                let bot = _.find(this.$store.state.botStaffList, bot => bot.bot_code === this.chatView.botCode);
                let me = StaffService.getMe();
                let user = _.find(bot.staffs, staff => staff.id === me.id);
                this.isBotLeader = (!!user.role_features && user.role_features.includes(this.$const.ROLE_FEATURES.ACCESS_LIVE_SUPPORT_PAGE_AS_LEADER));
                let customer = this.$store.state.chatView.customer;
                let last_user_interactive_time = customer.last_user_interactive_time ? new Date(customer.last_user_interactive_time) : null;
                let last_bot_conversation_time = customer.last_bot_conversation_time ? new Date(customer.last_bot_conversation_time) : null;
                let last_cs_conversation_time = customer.last_cs_conversation_time ? new Date(customer.last_cs_conversation_time) : null;
                let last_interactive = last_user_interactive_time ? last_user_interactive_time : last_bot_conversation_time > last_cs_conversation_time ? last_bot_conversation_time : last_cs_conversation_time;
                if (last_interactive) {
                    this.user_inactive_24h = moment().subtract(24, "hours").toDate() > last_interactive;
                } else {
                    this.user_inactive_24h = false;
                }

                if (customer.last_user_read_time) {
                    this.last_user_seen_time = moment(new Date(customer.last_user_read_time)).add(1, "seconds").toDate();
                } else {
                    this.last_user_seen_time = null;
                }

                this.last_user_seen_message = null;
              this.getAllCustomerAttributes();
              //this.getAllAgentQuickResponse();
              this.quoted_message = this.quoteMessages[this.chatView.senderId];
            }
            this.closeLoading();
            this.last_mark_typing = 0;
        },
        '$route': {
            immediate: true,
            handler: function () {
                // this.chatLog = [];
                this.openLoading();
                let { bot_code, senderId } = this.$route.params;
                this.$store.dispatch(this.$ActionTypes.CHANGE_CHAT_VIEW, {
                    botCode: bot_code,
                    senderId: senderId
                });
            }
        },
        message (value) {
            this.$nextTick(()=> {
              //Update message cache
              this.$store.commit(this.$ActionTypes.MESSAGE_CACHE, {sender_id: this.chatView.senderId, message: value})
              // let textarea = this.$refs.message
              // // textarea.style.height = 'auto';
              // textarea.style.height = `${textarea.scrollHeight - 20}px`
              // console.log(textarea.style.height)
            })
            if (value && value.length > 0) {
                this.mark_typing();
            } else {
                this.mark_typing_off();
            }
        },
        rssSource:{
            immediate: true,
            handler: function () {
                this.updateRss()
            }
        },
      notifyBotChat(val) {
          const data = val && val.data ? val.data : {};
          const {sender_id} = data;
          if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.MARK_AS_DONE) {
            // Delete message cache
            this.$store.commit(this.$ActionTypes.DEL_MESSAGE_CACHE, sender_id)
            // Reset message
            let currentSenderId = this.$route.params.senderId;
            if (sender_id === currentSenderId) {
              this.message = "";
              this.image = null;
              this.file = null;
            }
          } else if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.USER_DELETED_MESSAGE) {
              // check if current sender id is sender_id
              if (this.chatView.senderId && this.chatView.senderId === sender_id) {
                  // find chatlog with id is data._id
                  for (let i = 0; i < this.chatLog.length; i++) {
                      if (this.chatLog[i].id === data.chat_log._id) {
                          // change content message to deleted message
                          this.chatLog[i].content = {
                              "text": "This message has been deleted."
                          }
                          this.chatLog[i].type = "text";
                          this.chatLog[i].isDeleted = true;
                          this.$forceUpdate();
                          break;
                      }
                  }
              }
          }
      },
      chatLogsSortByTime(val){
          this.quoted_message=null;
      },
    }
}
</script>
<style scoped lang="scss">
    @import "style/chat-view";
</style>
